export const iconFontAwesomeAutomotiveTruck = (
	<i className="fa-solid fa-truck"></i>
);
